module.exports = __webpack_public_path__ + "static/media/xiaoshouzhengce.7b3f0419.png";